import type { FiltersPanelState } from "./types";

export const INITIAL_FILTERS_PANEL_STATE: FiltersPanelState = {
    selectedFilterCategory: "all",
    isFiltersCategoriesPanelExpanded: false,
    isFiltersPanelExpanded: true,
    expandedFilter: null,
    filterMode: "filters-list",
    searchQuery: "",
    isInitialFiltersReady: false,
};
